import * as React from 'react';
import { Link } from 'react-router-dom';

import { ReactFCC } from '@notino/react-styleguide';
import { masterUrl } from '@notino/shared/client-utils';

import { useModifyCacheAndChangePathname } from './useHandleClientRedirect';

export interface IClientRedirectProps {
  product: {
    url: string;
    id: string | number;
    catalogMasterId: string | number;
  };
  useMasterUrl: boolean;
}

export const ClientRedirect: ReactFCC<IClientRedirectProps> = ({
  children,
  useMasterUrl,
  product,
}) => {
  const modifyCacheAndChangePathname = useModifyCacheAndChangePathname();

  const handleOnClick = () => {
    modifyCacheAndChangePathname(product);
  };

  return (
    <Link
      to={useMasterUrl ? masterUrl(product.url) : product.url}
      onClick={handleOnClick}
    >
      {children}
    </Link>
  );
};
